<template>
  <a-modal
    title="食材及用量"
    :width="750"
    :maskClosable="false"
    :visible="showModal"
    @cancel="handleCancel"
    :footer="null"
  >
    <a-table
      :columns="columns"
      :dataSource="detailData"
      :loading="modalLoading"
      :pagination="false"
    >
    </a-table>
    <br />
  </a-modal>
</template>

<script>
const columns = [{
  title: '#',
  dataIndex: 'index',
  key: 'index'
}, {
  title: '食材名称',
  dataIndex: 'foodName',
  key: 'foodName'
}, {
  title: '编号',
  dataIndex: 'foodNo',
  key: 'foodNo'
}, {
  title: '重量',
  dataIndex: 'foodWeight',
  key: 'foodWeight'
}]

export default {
  data () {
    return {
      columns
    }
  },
  props: {
    showModal: Boolean,
    modalLoading: Boolean,
    data: Boolean,
    detailData: {
      type: Array,
      default: () => {
        return []
      }
    },
    totalPrice: {
      type: String,
      default: '0'
    }
  },

  methods: {
    handleCancel () {
      this.$emit('cancel')
    }

  }
}
</script>
<style lang="less" scoped>
</style>
